export const langList = [
  'en',
  'zh-hans'
];